module.exports = __webpack_public_path__ + "static/media/aramex.74a0a56c.svg";